import { decideLanguageOffer, recordLanguageChoice, recordLanguageOfferDismissed } from 'BomdisoftComponents/language-offer/offer';
import { DEFAULT_LANGUAGE_OFFER_TEST_ID, LANGUAGE_OFFER_TAG, renderLanguageOffer } from 'BomdisoftComponents/language-offer/render';
import { delegateTooltips } from 'BomdisoftComponents/tooltip/delegate';
import type { SupportedLanguageCode } from '@bomdisoft/translations';

export type LanguageOfferElementView = Window & typeof globalThis;

export const createLanguageOfferElement = (view: LanguageOfferElementView) =>
  class BomdisoftLanguageOffer extends view.HTMLElement {
    #offered: SupportedLanguageCode | undefined;

    connectedCallback() {
      this.#offered = decideLanguageOffer(view);
      this.addEventListener('click', this.#handleClick);
      if (this.#offered === undefined) return;
      const template = this.ownerDocument.createElement('template');
      template.innerHTML = renderLanguageOffer({ offered: this.#offered, testId: this.getAttribute('test-id') ?? DEFAULT_LANGUAGE_OFFER_TEST_ID }).value;
      this.replaceChildren(template.content);
      const root = this.getRootNode();
      if (root.nodeType === root.DOCUMENT_NODE || root.nodeType === root.DOCUMENT_FRAGMENT_NODE) delegateTooltips(root as Document | ShadowRoot);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      this.replaceChildren();
    }

    #handleClick = (event: Event) => {
      const target = event.target instanceof view.Element ? event.target : null;
      if (this.#offered === undefined || target === null) return;
      if (target.closest('.bomdisoft-language-offer-action') !== null) recordLanguageChoice(view, this.#offered);
      if (target.closest('.bomdisoft-language-offer-dismiss') === null) return;
      recordLanguageOfferDismissed(view);
      this.#offered = undefined;
      this.replaceChildren();
    };
  };

export const defineLanguageOffer = (view: LanguageOfferElementView | null = typeof window === 'undefined' ? null : window) => {
  if (view?.customElements === undefined || view.customElements.get(LANGUAGE_OFFER_TAG) !== undefined) return;
  view.customElements.define(LANGUAGE_OFFER_TAG, createLanguageOfferElement(view));
};
